import type { AreaRoutes } from "@/app/routes/hr/areaRoutes";

/* Time off and overtime: balances, leave requests, the team calendar, holidays and overtime. */
export const timeOffRoutes: AreaRoutes = {
  people: [
    {
      path: "time-off",
      lazy: async () => ({
        Component: (await import("@/features/time-off/routes/TimeOffHubLayout")).default,
      }),
      children: [
        {
          index: true,
          lazy: async () => ({
            Component: (await import("@/features/time-off/routes/WhosOutTab")).default,
          }),
        },
        {
          path: "requests",
          lazy: async () => ({
            Component: (await import("@/features/time-off/routes/LeaveRequestsTab")).default,
          }),
        },
        {
          path: "overtime",
          lazy: async () => ({
            Component: (await import("@/features/time-off/routes/OvertimeTab")).default,
          }),
        },
        {
          path: "balances",
          lazy: async () => ({
            Component: (await import("@/features/time-off/routes/BalancesTab")).default,
          }),
        },
        {
          path: "types",
          lazy: async () => ({
            Component: (await import("@/features/time-off/routes/LeaveTypesTab")).default,
          }),
        },
        {
          path: "holidays",
          lazy: async () => ({
            Component: (await import("@/features/time-off/routes/HolidaysTab")).default,
          }),
        },
      ],
    },
  ],
  employee: [
    {
      path: "time-off",
      lazy: async () => ({
        Component: (await import("@/features/time-off/routes/EmployeeTimeOffTab")).default,
      }),
    },
  ],
  me: [
    {
      path: "time-off",
      lazy: async () => ({
        Component: (await import("@/features/time-off/routes/MyTimeOffTab")).default,
      }),
    },
  ],
  top: [],
};
